import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import HeaderData from '../Form/HeaderData.jsx'
import PositionList from '../Form/PositionList.jsx'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider.js'

const EditReceiptContentArea = () => {
  const {
    formErrors,
    headerData,
    setHeaderDataByKey,
    resetErrorByFormKey,
    positions,
    loadedReceiptData,
    addPosition,
    copyPosition,
    splitPosition,
    setPositions,
    actionMode
  } = useLocalReceiptDataState()

  return (
    <Form>
      {
        !loadedReceiptData
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <HeaderData actionMode={actionMode} headerData={headerData} setHeaderDataByKey={setHeaderDataByKey} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            <PositionList actionMode={actionMode} addPosition={addPosition} copyPosition={copyPosition} splitPosition={splitPosition} positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
          </>
      }
    </Form>
  )
}

export default EditReceiptContentArea

